import { render, staticRenderFns } from "./Tmplt.speakers.vue?vue&type=template&id=211d543b&"
import script from "./Tmplt.speakers.vue?vue&type=script&lang=ts&"
export * from "./Tmplt.speakers.vue?vue&type=script&lang=ts&"
import style0 from "./Tmplt.speakers.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports